import React from 'react'

function Footer() {
    return (
        <div className='footer'>
            <p className='pt-2'>Designed and Developed By</p>
            <p>Michael AKin</p>
        </div>
    )
}

export default Footer
